<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="title"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <div>
            <b-row>
                <b-col>
                    <MdLookupMultiSelect
                        v-bind:Label="$tc('Shared.Form')"
                        v-bind:ModelCode="d_headerIds"
                        v-bind:RefCode="'NoteHeaderId'"
                        v-bind:Api="'NotesTypes/PatientPortalNoteSetup'"
                        v-bind:FieldCode="'notesid'"
                        v-bind:FieldDescription="'description'"
                        v-bind:Fields="fields"
                        :SearchTitle="$t('PPDbForm.SearchNote')"
                        :GetValues="getNoteHeaderIdValues"
                        :SearchFieldCode="'notesid'"
                        v-bind:isValid="isSelectionValid"
                        v-bind:isRequired="true"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <MdLookupMultiSelect
                        v-bind:Label="$t('Shared.Packages')"
                        v-bind:ModelCode="d_packageIds"
                        v-bind:RefCode="'NotePackageId'"
                        v-bind:Api="'PatientPortalNotePackageHdrs'"
                        v-bind:FieldCode="'packageId'"
                        v-bind:FieldDescription="'description'"
                        v-bind:Fields="packageFields"
                        :SearchTitle="$t('PPDbForm.SearchPackage')"
                        :GetValues="getPackageIdValues"
                        :SearchFieldCode="'description'"
                        v-bind:isValid="isSelectionValid"
                        v-bind:isRequired="true"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" sd="6" lg="6">
                    <MdDateTime
                        :Label="$t('Shared.ExpirationDate')"
                        :Model="d_expirationDate"
                        @input="d_expirationDate = $event"
                        :Id="'ExpirationDate'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isExpirationDateValid"
                    >
                    </MdDateTime>
                </b-col>
            </b-row>
        </div>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import Utils from '@/common/utils';
import PatientPortalNotePackageHdrsService from '@/services/patientPortalNotePackageHdrs.service';

export default {
    name: 'PatientPortalAssignNote',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCode: {
            type: String,
            required: true
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalAssignNoteModal',
            emitCloseEvent: false,
            d_expirationDate: null,
            d_headerIds: [],
            d_packageIds: [],
            isExpirationDateValid: true,
            isSelectionValid: true,
            fields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-left'
                }
            ],
            packageFields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-left'
                },
                {
                    key: 'noteCount',
                    sortable: true,
                    label: this.$t('PPDbSetup.FormsPackagesTab.NoteCount'),
                    class: 'text-center'
                }
            ]
        };
    },
    computed: {
        title() {
            return `${this.$t('PPDbForm.AddForm')}`;
        }
    },
    methods: {
        resetData() {
            this.isExpirationDateValid = true;
            this.isSelectionValid = true;
            this.d_expirationDate = null;
            this.d_headerIds = [];
            this.d_packageIds = [];
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        async emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                let noteIdList;
                try {
                    noteIdList = await this.buildNoteIdList();
                } catch (error) {
                    this.showResponseErrorMessage(error);
                    return;
                }

                this.$emit('update:visible', false);
                this.$emit('ok', {
                    noteIdList,
                    expirationDate: this.d_expirationDate
                });
                this.resetData();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        async buildNoteIdList() {
            const noteIdList = [...this.d_headerIds];

            if (this.d_packageIds.length > 0) {
                const response = await PatientPortalNotePackageHdrsService.getNotesIds(
                    this.d_packageIds
                );
                (response.data || []).forEach(noteId => {
                    if (!noteIdList.includes(noteId)) {
                        noteIdList.push(noteId);
                    }
                });
            }

            return noteIdList;
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate_required() {
            this.isExpirationDateValid =
                Utils.isNullOrEmptyString(this.d_expirationDate) ||
                Utils.isValidDate(this.d_expirationDate);
            this.isSelectionValid =
                (Array.isArray(this.d_headerIds) && this.d_headerIds.length > 0) ||
                (Array.isArray(this.d_packageIds) && this.d_packageIds.length > 0);

            return this.isExpirationDateValid && this.isSelectionValid;
        },

        getNoteHeaderIdValues(values) {
            this.d_headerIds = values || [];
        },

        getPackageIdValues(values) {
            this.d_packageIds = values || [];
        }
    }
};
</script>
